import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FuseConfirmDialogComponent} from '../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AttributeValue} from '../attributes/attributes.model';
import {AttributesComponent} from '../attributes/attributes.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SystemService} from '../../services/system.service';
import {TranslateService} from '@ngx-translate/core';
import {ICC, InstrumentType} from '../../interfaces/interfaces';
import {InstrumentService} from '../instrument/instrument.service';
import {Subject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-instrument-type',
    templateUrl: './instrument-type.component.html',
    styleUrls: ['./instrument-type.component.scss']
})
export class InstrumentTypeComponent implements OnInit, OnDestroy {

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    public instrumentTypeForm: FormGroup;
    public action: string;
    public instrumentType: InstrumentType;
    private confirmP: string;
    format: any = { add: 'Agregar', remove: 'Quitar', all: 'Todos',
        none: 'Niguno', direction: 'left-to-right', draggable: false, locale: undefined };

    @Input()
    public title: string;

    @Output('entityChanged')
    changed: EventEmitter<any> = new EventEmitter();
    
    attributes: AttributeValue[];

    @ViewChild('attributesComp')
    attributesComp: AttributesComponent;
    iccList: ICC[] = [];
    // private subscriptions = new Subscription();
    private _unsubscribeAll: Subject<unknown> = new Subject();



    constructor(private _formBuilder: FormBuilder,

                private _matSnackBar: MatSnackBar,
                public _systemService: SystemService,
                public _instrumentService: InstrumentService,
                public translate: TranslateService,
                public _matDialog: MatDialog) {
        // this.client = new Client();
    }

    ngOnInit(): void {
        this.translate.use(this._systemService.visibility.language);

        // Obtener la lista de ICC disponibles
        this._instrumentService.allIcc$.pipe(
            takeUntil(this._unsubscribeAll),
        ).subscribe(iccList => {
            this.iccList = iccList;
        });
    }

    // get formArray$(): Observable<AbstractControl[]>{
    //     return this._formArray.asObservable();
    // }


    deleteInstrumentType(): void {
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = '¿Está seguro que desea eliminar este tipo de instrumento?';

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this._instrumentService.deleteInstrumentType(this.instrumentType.id).subscribe(
                    () => {
                        this._matSnackBar.open('Tipo de instrumento eliminado', 'OK', {
                            verticalPosition: 'top',
                            duration: 4000
                        });
                        // this.changed.emit(this.instrumentType.id);
                    },
                    error => {
                        this._matSnackBar.open('Error al eliminar el tipo de instrumento', 'OK', {
                            verticalPosition: 'top',
                            duration: 4000
                        });
                    }
                );
            }
            this.confirmDialogRef = null;
        });
    }


    guardarInstrumentType(): void {
        const theInstrumentType: any = new InstrumentType(this.instrumentTypeForm.getRawValue());
        // theInstrumentType.attributes = this.attributes;

        this._instrumentService.saveInstrumentType(theInstrumentType).subscribe(
            resp => {
                // Show the success message
                this._matSnackBar.open('Tipo de instrumento guardado', 'OK', {
                    verticalPosition: 'top',
                    duration: 4000
                });

                // Notificar al componente padre
                this.changed.emit(resp);
            }
        );
    }



    selected(entity): void {
        this.instrumentType = entity;
        if (entity) {
            this.instrumentTypeForm = this.createInstrumentTypeForm();
            // this.attributes = [];
            // this.getAttributes(entity);
            // this.ngOnInit();
        }
    }

    ngOnDestroy(): void {
        // Limpiar suscripciones
        this._unsubscribeAll.next();
    }

    // Función para comparar objetos ICC en el selector
    compareIcc(icc1: ICC, icc2: ICC): boolean {
        if (!icc1 || !icc2) {
            return false;
        }
        return icc1.id === icc2.id;
    }

    createInstrumentTypeForm(): FormGroup {
        return this._formBuilder.group({
            id: [this.instrumentType.id],
            name: [this.instrumentType.name],
            description: [this.instrumentType.description],
            icc: [this.instrumentType.icc],
            calibrationPrice: [this.instrumentType.calibrationPrice],
            batteryPrice: [this.instrumentType.batteryPrice],
            casePrice: [this.instrumentType.casePrice],
            fusePrice: [this.instrumentType.fusePrice],
            cablesPrice: [this.instrumentType.cablesPrice],
        });
    }

}
